<template>
  <div class="review-section">
    <div class="container flex flex-wrap justify-center mt-12">
      <header class="w-full pb-10 text-center h2 text-white">Wat mensen zeggen over {{ firstName }}</header>

      <main class="relative flex flex-wrap w-full lg:w-3/4">
        <section v-for="review in activeReviews" :key="review.title" class="w-full lg:w-auto flex-auto lg:flex-1 flex text-white pr-6 pb-12 lg:mb-0">
          <figure v-if="review.active_image" class="mr-6">
            <img :src="review.active_image.url" class="clip-circle object-cover">
          </figure>
          <div class="flex-shrink text-sm">
            <span class="prose" v-html="review.tekst"/>
            <div>- <strong>{{ review.title }}</strong></div>
          </div>
        </section>
        <button v-if="reviewsLength > sliderSize" class="slider-button slider-button--left" @click="prev">
          <font-awesome-icon :icon="['fas', 'chevron-left']"/>
        </button>
        <button v-if="reviewsLength > sliderSize" class="slider-button slider-button--right" @click="next">
          <font-awesome-icon :icon="['fas', 'chevron-right']"/>
        </button>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    firstName: {
      type: String,
      default: '',
    },
    reviews: {
      type: Array,
      default: () => ([]),
    },
    sliderSize: {
      type: Number,
      default: 2,
    },
  },
  data: () => ({
    activeIndex: 0,
  }),
  computed: {
    activeReviews() {
      const start = this.activeIndex * this.sliderSize;
      return this.reviews.slice(start, start + this.sliderSize);
    },
    reviewsLength() {
      return this.reviews.length;
    },
  },
  methods: {
    next() {
      if (this.activeIndex < Math.ceil(this.reviewsLength / this.sliderSize) - 1) {
        this.activeIndex++;
      } else {
        this.activeIndex = 0;
      }
    },
    prev() {
      if (this.activeIndex > 0) {
        this.activeIndex--;
      } else {
        this.activeIndex = Math.ceil(this.reviewsLength / this.sliderSize) - 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.review-section {
  @apply overflow-hidden;
  min-height: 340px;
  background-image: linear-gradient(to right, theme('colors.secondary.default'), theme('colors.secondary.default') 10%, theme('colors.secondary.light') 90%);
  .clip-circle {
    clip-path: circle(60px at center);
    max-width: 120px;
  }
  .slider-button {
    @apply flex absolute items-center justify-center border border-white text-white text-xs;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    &--left {
      top: 50%;
      left: -10%;
    }
    &--right {
      top: 50%;
      right: -10%;
    }
  }
}
</style>
